// https://www.notion.so/deepsight/Mapping-produit-produits-caisses-plus-d-velopp-895eec7c0e13487cb65ff60010670052?pvs=4
export const SIGNIFICANCE_THRESHOLD_SIMILARITY_SCORE_MAPPING = 99;
